// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderInfoModal_btnClose__1C1Bb {
  width: 28px;
  height: 28px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: var(--gray-20);
  color: var(--gray-180);
  margin-left: auto;
  transition: var(--transition);
  transition-property: background-color, opacity;
}
@media (hover: hover) {
  .OrderInfoModal_btnClose__1C1Bb:hover {
    opacity: 0.8;
  }
}

.OrderInfoModal_title__NYXap {
  min-height: 24px;
  min-width: 200px;
  border-radius: 8px;
}
.OrderInfoModal_title__NYXap::first-letter {
  text-transform: capitalize;
}
.OrderInfoModal_title__NYXap.skeletonBlock {
  font-size: 0;
}
.OrderInfoModal_title__NYXap span {
  font-weight: normal;
}

.OrderInfoModal_main__c32tA {
  display: flex;
}

.OrderInfoModal_aside__cnk7K {
  width: var(--modal-aside-width);
  flex-shrink: 0;
  border-right: 1px solid #E0E7EB;
  display: flex;
  flex-direction: column;
}

.OrderInfoModal_aside-lg__ohIJT {
  width: var(--modal-aside-width-lg);
}

.OrderInfoModal_footer__qgwsZ {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 24px;
  margin-top: auto;
}
@media (min-width: 1200px) {
  .OrderInfoModal_footer__qgwsZ {
    border-top: 1px solid #E0E7EB;
    min-height: var(--modal-footer-height);
    padding: 8px 8px 7px;
  }
}
.OrderInfoModal_footer__qgwsZ.OrderInfoModal_footer__painted__JYqju {
  background: #FAFAFA;
  padding: 12px;
  border-bottom-left-radius: 16px;
}
@media (max-width: 1200px) {
  .OrderInfoModal_footer__qgwsZ.OrderInfoModal_footer__painted__JYqju {
    background: none;
    padding: 0 0 16px;
  }
}

.OrderInfoModal_dummyChat__MIHUe {
  min-height: 592px;
  width: 100%;
}

.OrderInfoModal_dummyChat__MIHUe {
  background-color: var(--white);
}

.OrderInfoModal_img__rIOqs {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 15px;
}

.OrderInfoModal_active-or-history-modal__gZov\\+ {
  padding: 0;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner {
  max-width: none;
  border-radius: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner .modal__header {
  padding: 0 0 12px 0;
  min-height: max-content;
  margin: 24px 16px 16px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner .modal__header .titleBack__back {
  width: 36px;
  height: 36px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner .modal__body {
  flex-grow: 1;
  display: flex;
}
.OrderInfoModal_active-or-history-modal__gZov\\+.OrderInfoModal_opened-mobile-chat__e\\+tgm .modal__inner {
  padding: 0;
}
.OrderInfoModal_active-or-history-modal__gZov\\+.OrderInfoModal_opened-mobile-chat__e\\+tgm .modal__inner .modal__header {
  padding: 16px;
  margin: 0;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_main__c32tA {
  flex-grow: 1;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_aside__cnk7K {
  width: 100%;
  border: none;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: auto;
  gap: 8px;
  padding: 16px 24px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu button {
  height: 44px;
}
@media (min-width: 640px) {
  .OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu button {
    height: 54px;
  }
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu .btn_orange {
  margin-bottom: 16px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__topTwoBtns__WJTXC {
  display: flex;
  gap: 8px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__bottomTwoBtns__XMs8m {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__bottomTwoBtns__XMs8m .OrderInfoModal_back-btn__Eql11 {
  width: 50%;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__bottomTwoBtns__XMs8m .OrderInfoModal_messenger-btn__Pea6W {
  gap: 4px;
}

.OrderInfoModal_mobile-chat__3WOOC {
  width: 100%;
  position: initial;
}

.OrderInfoModal_messagesNoReview__0Kbc4 {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 11px;
  line-height: 11px;
  background: #FF3C3C;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid #FAFAFA;
  color: #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OrderInfoModal/OrderInfoModal.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,8CAAA;AACF;AACE;EACE;IACE,YAAA;EACJ;AACF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AAHF;AAKE;EANF;IAOI,6BAAA;IACA,sCAAA;IACA,oBAAA;EAFF;AACF;AAIE;EACE,mBAAA;EACA,aAAA;EACA,+BAAA;AAFJ;AAII;EALF;IAMI,gBAAA;IACA,iBAAA;EADJ;AACF;;AAKA;EACE,iBAAA;EACA,WAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,UAAA;AAFF;AAKI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAHN;AAKM;EACE,mBAAA;EACA,uBAAA;EACA,sBAAA;AAHR;AAKQ;EACE,WAAA;EACA,YAAA;AAHV;AAOM;EAIE,YAAA;EACA,aAAA;AARR;AAeM;EACE,UAAA;AAbR;AAeQ;EACE,aAAA;EACA,SAAA;AAbV;AAmBE;EAIE,YAAA;AApBJ;AAuBE;EACE,WAAA;EACA,YAAA;AArBJ;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;AAtBJ;AAwBI;EACE,YAAA;AAtBN;AAwBM;EAHF;IAII,YAAA;EArBN;AACF;AAyBM;EACE,mBAAA;AAvBR;AA2BI;EACE,aAAA;EACA,QAAA;AAzBN;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA1BN;AA4BM;EACE,UAAA;AA1BR;AA6BM;EACE,QAAA;AA3BR;;AAiCA;EAIE,WAAA;EACA,iBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCF","sourcesContent":[".btnClose {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  background-color: var(--gray-20);\r\n  color: var(--gray-180);\r\n  margin-left: auto;\r\n  transition: var(--transition);\r\n  transition-property: background-color, opacity;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n}\r\n\r\n.title {\r\n  min-height: 24px;\r\n  min-width: 200px;\r\n  border-radius: 8px;\r\n\r\n  &::first-letter {\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  &:global(.skeletonBlock) {\r\n    font-size: 0;\r\n  }\r\n\r\n  span {\r\n    font-weight: normal;\r\n  }\r\n}\r\n\r\n.main {\r\n  display: flex;\r\n}\r\n\r\n.aside {\r\n  width: var(--modal-aside-width);\r\n  flex-shrink: 0;\r\n  border-right: 1px solid #E0E7EB;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.aside-lg {\r\n  width: var(--modal-aside-width-lg);\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-bottom: 24px;\r\n  margin-top: auto;\r\n\r\n  @media (min-width: 1200px) {\r\n    border-top: 1px solid #E0E7EB;\r\n    min-height: var(--modal-footer-height);\r\n    padding: 8px 8px 7px;\r\n  }\r\n\r\n  &.footer__painted {\r\n    background: #FAFAFA;\r\n    padding: 12px;\r\n    border-bottom-left-radius: 16px;\r\n\r\n    @media (max-width: 1200px) {\r\n      background: none;\r\n      padding: 0 0 16px;\r\n    }\r\n  }\r\n}\r\n\r\n.dummyChat {\r\n  min-height: 592px;\r\n  width: 100%;\r\n}\r\n\r\n.dummyChat {\r\n  background-color: var(--white);\r\n}\r\n\r\n.img {\r\n  width: 40px;\r\n  height: 40px;\r\n  object-fit: cover;\r\n  border-radius: 100%;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n  margin-right: 15px;\r\n}\r\n\r\n.active-or-history-modal {\r\n  padding: 0;\r\n\r\n  :global {\r\n    .modal__inner {\r\n      max-width: none;\r\n      border-radius: 0;\r\n      height: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n      overflow: auto;\r\n\r\n      .modal__header {\r\n        padding: 0 0 12px 0;\r\n        min-height: max-content;\r\n        margin: 24px 16px 16px;\r\n\r\n        .titleBack__back {\r\n          width: 36px;\r\n          height: 36px;\r\n        }\r\n      }\r\n\r\n      .modal__body {\r\n        // тест изменения модалки. Если все норм, потом удалить\r\n        // height: 100%;\r\n\r\n        flex-grow: 1;\r\n        display: flex;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.opened-mobile-chat {\r\n    :global {\r\n      .modal__inner {\r\n        padding: 0;\r\n\r\n        .modal__header {\r\n          padding: 16px;\r\n          margin: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .main {\r\n    // тест изменения модалки. Если все норм, потом удалить\r\n    // height: 100%;\r\n\r\n    flex-grow: 1;\r\n  }\r\n\r\n  .aside {\r\n    width: 100%;\r\n    border: none;\r\n  }\r\n\r\n  .btn-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    margin-top: auto;\r\n    gap: 8px;\r\n    padding: 16px 24px;\r\n    \r\n    button {\r\n      height: 44px;\r\n\r\n      @media (min-width: 640px) {\r\n        height: 54px;\r\n      }\r\n    }\r\n  \r\n    :global {\r\n      .btn_orange {\r\n        margin-bottom: 16px;\r\n      }\r\n    }\r\n\r\n    &__topTwoBtns {\r\n      display: flex;\r\n      gap: 8px;\r\n    }\r\n\r\n    &__bottomTwoBtns {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 8px;\r\n\r\n      .back-btn {\r\n        width: 50%;\r\n      }\r\n\r\n      .messenger-btn {\r\n        gap: 4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.mobile-chat {\r\n  // тест изменения модалки. Если все норм, потом удалить\r\n  // position: absolute;\r\n  // height: calc(100% - 69px);\r\n  width: 100%;\r\n  position: initial;\r\n}\r\n\r\n.messagesNoReview {\r\n  position: absolute;\r\n  top: -10px;\r\n  right: -10px;\r\n  font-size: 11px;\r\n  line-height: 11px;\r\n  background: #FF3C3C;\r\n  border-radius: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 2px solid #FAFAFA;\r\n  color: #FAFAFA;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnClose": `OrderInfoModal_btnClose__1C1Bb`,
	"title": `OrderInfoModal_title__NYXap`,
	"main": `OrderInfoModal_main__c32tA`,
	"aside": `OrderInfoModal_aside__cnk7K`,
	"aside-lg": `OrderInfoModal_aside-lg__ohIJT`,
	"footer": `OrderInfoModal_footer__qgwsZ`,
	"footer__painted": `OrderInfoModal_footer__painted__JYqju`,
	"dummyChat": `OrderInfoModal_dummyChat__MIHUe`,
	"img": `OrderInfoModal_img__rIOqs`,
	"active-or-history-modal": `OrderInfoModal_active-or-history-modal__gZov+`,
	"opened-mobile-chat": `OrderInfoModal_opened-mobile-chat__e+tgm`,
	"btn-container": `OrderInfoModal_btn-container__FahOu`,
	"btn-container__topTwoBtns": `OrderInfoModal_btn-container__topTwoBtns__WJTXC`,
	"btn-container__bottomTwoBtns": `OrderInfoModal_btn-container__bottomTwoBtns__XMs8m`,
	"back-btn": `OrderInfoModal_back-btn__Eql11`,
	"messenger-btn": `OrderInfoModal_messenger-btn__Pea6W`,
	"mobile-chat": `OrderInfoModal_mobile-chat__3WOOC`,
	"messagesNoReview": `OrderInfoModal_messagesNoReview__0Kbc4`
};
export default ___CSS_LOADER_EXPORT___;
